export enum KnelpuntenMeerkeuzeEnum {
  AMBTELIJKE_CAPACITEIT = 'Ambtelijke capaciteit',
  ANDERS = 'Anders',
  BEREIKBAARHEID = 'Bereikbaarheid',
  GELUIDSHINDER = 'Geluidshinder',
  GROND_DIDAM = 'Grond/Didam',
  MAATSCHAPPELIJK_DRAAGVLAK = 'Maatschappelijk draagvlak',
  ONRENDABELE_TOP = 'Onrendabele top',
  SPUITZONES_MILIEU = 'Spuitzones/milieu',
  STIKSTOF = 'Stikstof',
  VERVUILDE_GROND = 'Vervuilde grond',
  FLORA_FAUNA = 'Flora/fauna',
  NUTS = 'Nuts',
  GEEN = 'Geen',
}
